import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { closeMessageDialog } from '@app-core/app/actions'
import MessageDialog from './MessageDialog'

class MessageDialogContainer extends PureComponent {
  render() {
    const { isOpen, title, message, closeMessageDialog } = this.props
    return (
      <MessageDialog isOpen={isOpen} title={title} message={message} onClose={closeMessageDialog} />
    )
  }
}

const mapStateToProps = (state) => ({
  isOpen: state.app.getIn(['messageDialog', 'isOpen']),
  title: state.app.getIn(['messageDialog', 'title']),
  message: state.app.getIn(['messageDialog', 'message']),
})

export default connect(mapStateToProps, {
  closeMessageDialog,
})(MessageDialogContainer)
